import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {addLocale} from "primereact/api";
import {Calendar} from "primereact/calendar";
import axios from "axios";
import moment from "moment/moment";
import {Dialog} from "primereact/dialog";
import EmployeecompensationListComponent from "../employeecompensation/EmployeecompensationListComponent";
import EmployeecompensationFormComponent from "../employeecompensation/EmployeecompensationFormComponent";

const EmploymentListComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [employments, setEmployments] = useState([]);
  const [endofprobationary, setEndofprobationary] = useState();
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });
  const [expandedRows, setExpandedRows] = useState(null);

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      if (entity === 'employee') {
        query = query + '&search[employee][operator]=%3D&search[employee][value]=' + id
      }
      apiCall('get', '/api/v2/employment' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setEmployments(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {/*{localStorage.getItem('roles').toString().includes('role_') &&*/}
        {/*  <Button icon="pi pi-euro" className="p-button-warning p-mr-2"*/}
        {/*          disabled={rowData.end_date}*/}
        {/*          tooltip="{t('wages')}" tooltipOptions={{position: 'left'}}*/}
        {/*          onClick={() => {*/}
        {/*            if (entity === 'employment') {*/}
        {/*              history.push('/hr/employment?create=compensation&employmentId=' + rowData.id)*/}
        {/*            }*/}
        {/*            if (entity === 'employee') {*/}
        {/*              history.push('/hr/employee/read/' + id + '?create=compensation&employmentId=' + rowData.id)*/}
        {/*            }*/}
        {/*          }}/>*/}
        {/*}*/}
        {localStorage.getItem('roles').toString().includes('role_') &&
          <Button icon="pi pi-sign-out" className="p-button-danger p-mr-2"
                  disabled={rowData.end_date}
                  tooltip="Foglalkoztatás vége" tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (entity === 'employment') {
                      history.push('/hr/employment?create=eop&employmentId=' + rowData.id)
                    }
                    if (entity === 'employee') {
                      history.push('/hr/employee/read/' + id + '?create=eop&employmentId=' + rowData.id)
                    }
                  }}/>
        }
        {localStorage.getItem('roles').toString().includes('role_employment_write') &&
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (entity === 'employment') {
                      history.push('/hr/employment/update/' + rowData.id)
                    }
                    if (entity === 'employee') {
                      history.push('/hr/employee/read/' + id + '?update=employment&employmentId=' + rowData.id)
                    }
                  }}/>
        }
        {localStorage.getItem('roles').toString().includes('role_') &&
          <Button icon="pi pi-trash" className="p-button-danger"
                  tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      setLoading(true);
                      apiCall('delete', '/api/v2/employment/' + rowData.id)
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres törlés!');
                          window.App.setState({rerenderEmploymentList: Math.random()})
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoading(false);
                        })
                    }
                  }}
          />
        }
      </React.Fragment>
    );
  }

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderEmploymentList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={employments} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
                 rowExpansionTemplate={(rowData) => {
                   return (
                     <>
                        <div className="expanded-section expanded-section--compensation">
                          <h4 className="expanded-section__title">
                            <i className="pi pi-euro" />
                            {t('wages')}
                          </h4>
                          <div className="expanded-section__content">
                            <EmployeecompensationListComponent employmentId={rowData.id}/>
                          </div>
                          <div className={"p-grid p-mt-1"}>
                            <div className={"p-col-12 p-lg-6 p-xl-6"}>
                            </div>
                            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
                              <Button type="button" label={t('addWage')} icon="pi pi-plus"
                                      className="p-button-success p-button-sm p-ml-2"
                                      onClick={() => {
                                        let _params = '?'
                                        Object.entries(window.App.urlVars()).map(([key, value]) => {
                                          _params += key + '=' + value + '&'
                                        })
                                        _params += 'create=compensation&employmentId=' + rowData.id + '&employeeId=' + rowData.employee.id
                                        history.push(window.location.hash.replace('#', '') + _params)
                                      }}
                              />
                              <Dialog visible={window.App.urlVars().create === 'compensation' || window.App.urlVars().update === 'compensation'}
                                      style={{width: '980px'}}
                                      header={t('wageData')}
                                      modal
                                      onHide={() => {
                                        history.go(-1)
                                      }}>
                                <EmployeecompensationFormComponent  employeeId={id}/>
                              </Dialog>
                            </div>
                          </div>
                       </div>
                     </>
                   )
                 }}
                 expandedRows={expandedRows}
                 onRowToggle={(e) => {
                  const rows = e.data;
                  if (!rows || Object.keys(rows).length === 0) {
                    setExpandedRows(null);
                    return;
                  }
                  const id = Object.keys(rows)[0];
                  setExpandedRows({[id]: true});
                }}
                 onRowExpand={(e) => {
                   let id = e.data.id
                   setExpandedRows({[id]: true})
                 }}
      >
        {entity !== 'employee' &&
          <Column field="employee.name" header={t('columnEmployee')} bodyClassName="col-body-font-bold" filter filterField="employee_name"></Column>
        }
        <Column field="employment_type.name" header={t('columnType2')} filter filterField='employment_type_name'></Column>
        <Column field="remote_work" header={t('columnRemoteWork')} sortable filter body={(rowData) => {
          return (
            <>{t('remote_work_' + rowData.remote_work)}</>
          )
        }}></Column>
        <Column field="start_date" header={t('columnStart2')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.start_date)}</>
          )
        }}></Column>
        <Column field="end_date" header={t('columnEnd2')} sortable body={(rowData) => {
          return (
            <>
              {rowData.end_date ? (
                <>
                  {window.App.formatDateValue(rowData.end_date)}
                </>
              ) : (
                <span style={{opacity: 0.5}}>?</span>
              )}
            </>
          )
        }}></Column>
        <Column field="end_of_probationary" header={t('columnProbationPeriod')} sortable body={(rowData) => {
          return (
            <>
              {rowData.end_of_probationary ? (
                <>
                  {window.App.formatDateValue(rowData.end_of_probationary)}
                </>
              ) : (
                <span style={{opacity: 0.5}}>?</span>
              )}
            </>
          )
        }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
        <Column expander style={{width: '3em'}}/>
      </DataTable>
      <Dialog visible={window.App.urlVars().create === 'eop'}
              style={{width: '450px'}}
              header="Foglalkoztatás lezárása"
              modal
              onHide={() => {
                history.go(-1)
              }}>
        <div className={"p-grid"}>
          <div className={"p-col"}>
<span className="p-inputgroup p-mr-2">
            <Calendar value={endofprobationary}
                      locale="hu"
                      dateFormat={'yy-mm-dd'}
                      onChange={(e) => {
                        setEndofprobationary(moment(e.value, 'YYYY-DD-MM').endOf('day').toISOString())
                      }}/>
            <Button icon="pi pi-sign-out" className="p-button-danger"
                    label="Foglalkoztatás vége" tooltipOptions={{position: 'left'}}
                    onClick={() => {
                      if (window.confirm('A foglalkoztatás lezárásának megerősítésére van szükség!')) {
                        setLoading(true);
                        apiCall('patch', '/api/v2/employment/' + window.App.urlVars().employmentId,
                          {
                            end_date: endofprobationary
                          })
                          .then(response => {
                            window.App.toastShow('success', 'Sikeres mentés!');
                            window.App.setState({rerenderEmploymentList: Math.random()})
                            history.go(-1)
                          })
                          .catch(error => {
                            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                          })
                          .finally(() => {
                            setLoading(false);
                          })
                      }
                    }}
            />
          </span>
          </div>
        </div>
      </Dialog>
    </>
  )
}
export default withTranslation('common')(EmploymentListComponent);
